/**
 * Задержка выполнения кода на указанное количество миллисекунд.
 * @param ms - Количество миллисекунд, на которое нужно задержать выполнение.
 */
export const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
